import { Component, Input, ViewChild } from '@angular/core';
import {
  ObservationDefinition,
  ObservationDefinitionIdentifier,
} from 'app/mdm/lib/observation-definition/observation-definition';
import { EditableFlexTableComponent } from '@heda/core-hospital-ui';

@Component({
  selector: 'hw-observation-definition-identifiers-table',
  templateUrl: 'observation-definition-identifiers-table.component.html',
})
export class ObservationDefinitionIdentifiersTableComponent {
  @Input() public editMode: boolean = true;
  @Input() public definition: ObservationDefinition;
  @ViewChild('identifiersTable') public identifiersTable: EditableFlexTableComponent<ObservationDefinitionIdentifier>;

  public defaultIdentifierRow: ObservationDefinitionIdentifier = new ObservationDefinitionIdentifier();

  public validate(): boolean {
    return this.identifiersTable.validate();
  }
}
